<template>
  <div class="flex flex-column gap-4">
    <div class="flex justify-content-between align-items-center">
      <h3 class="m-0">Notes</h3>
      <a-button
        :loading="loading"
        :disabled="(associate?.note ?? '').trim() === note.trim()"
        type="primary"
        @click="handleSubmit"
        >Send Note</a-button
      >
    </div>
    <a-textarea v-model="note" placeholder="Type the note" :rows="10" :maxLength="512" />
  </div>
</template>

<script>
import { deepCopy } from '@/utils/deep-copy'
import { Input, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-textarea': Input.TextArea
  },
  data() {
    return {
      note: '',
      loading: false
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  watch: {
    associate: {
      handler(newVal) {
        if (newVal) {
          this.note = newVal.note ?? ''
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...profileActions(['updateAssociate', 'setAssociate']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async handleSubmit() {
      this.loading = true

      const payload = {
        associate: {
          ...this.associate,
          note: this.note.trim()
        }
      }

      const tempAssociate = deepCopy(this.associate)

      this.setAssociate(payload.associate)

      try {
        await this.updateAssociate(payload)

        this.showNotification('success', 'Success', "Associate's note successfully updated")
      } catch (error) {
        this.setAssociate(tempAssociate)

        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
